'use strict';

var htmlParser = require('parse5');
var React = require('react');
var convertAttr = require('react-attr-converter');
var styleParser = require('./lib/style-parser');

function renderNode(node, key, customComponents = {}) {
  let renderTheNode = (node, key) => renderNode(node, key, customComponents);

  if (node.nodeName === '#text') {
    if(customComponents.Text) {
      return <customComponents.Text value={node.value} key={key} />
    }

    return node.value;
  }

  if (node.nodeName === '#comment') {
    return node.value;
  }

  let Comp = node.tagName;

  if(node.tagName in customComponents) {
      Comp = customComponents[node.tagName];
  }

  var attr = node.attrs.reduce(function (result, attr) {
    var name = convertAttr(attr.name);
    result[name] = name === 'style' ? styleParser(attr.value) : attr.value;
    return result;
  }, {key: key});

  if (node.childNodes.length === 0) {
    return React.createElement(Comp, attr);
  }

  if (node.nodeName === 'script') {
    attr.dangerouslySetInnerHTML = {__html: node.childNodes[0].value};
    return React.createElement('script', attr);
  }

  var children = node.childNodes.map(renderTheNode);

  return React.createElement(Comp, attr, children);
}

function renderHTML(html, customComponents = {}) {
  var htmlAST = htmlParser.parseFragment(html);

  if (htmlAST.childNodes.length === 0) {
    return null;
  }

  let renderTheNode = (node, key) => renderNode(node, key, customComponents);

  var result = htmlAST.childNodes.map(renderTheNode);
  return result.length === 1 ? result[0] : result;
}

module.exports = renderHTML;
